var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"network-error"},[_c('img',{staticClass:"icon-img",attrs:{"src":_vm.iconImg}}),_vm._v(" "),_c('h1',[_vm._v("加载失败")]),_vm._v(" "),_c('p',[_vm._v("暂无内容显示")]),_vm._v(" "),(_vm.showRefresh)?_c('a',{on:{"click":_vm.refresh}},[_vm._v("刷新")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29edbe28","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/marketing_components/network-error/index.vue
// module id = 498
// module chunks = 1 2 14